'use client';

import { HStack } from '@terra/ui-styled-system';
import { MetaDefault } from '../../components/typography';

export type FilteredCounterProps = {
  filteredCount?: number;
  totalCount?: number;
  entityLabel: string;
};

export function FilteredCounter({
  filteredCount,
  totalCount,
  entityLabel,
}: FilteredCounterProps) {
  if (filteredCount === undefined && totalCount === undefined) {
    return null;
  }

  const resolvedFilteredCount = filteredCount ?? totalCount;
  const resolvedTotalCount = totalCount ?? filteredCount;

  if (resolvedFilteredCount === undefined) {
    return null;
  }

  const shouldShowRatio =
    resolvedTotalCount !== undefined &&
    resolvedFilteredCount !== resolvedTotalCount;
  const countText = shouldShowRatio
    ? `${resolvedFilteredCount.toLocaleString()} / ${resolvedTotalCount.toLocaleString()}`
    : resolvedFilteredCount.toLocaleString();

  return (
    <HStack
      gap="0"
      alignItems="center"
      justifyContent="flex-start"
      flexShrink={0}
      whiteSpace="nowrap"
    >
      <MetaDefault
        color="fg.muted"
        whiteSpace="nowrap"
        textAlign="left"
        style={{ fontVariantNumeric: 'tabular-nums' }}
      >
        {countText} {entityLabel}
      </MetaDefault>
    </HStack>
  );
}
